import axios from "axios";

class _AXIOS {
    get = (url = null, params = {}) => {
        try {
            if (url) {
                return axios.get(url, { params });
            }

            console.log("Axios GET error", "Url is null");
        } catch (err) {
            console.error("Axios POST error", err);
        }
    };

    post = (url = null, params = {}) => {
        try {
            if (url) {
                return axios.post(url, { params });
            }
            console.log("Axios POST error", "Url is null");
        } catch (err) {
            console.error("Axios POST error", err);
        }
    };
}

export default _AXIOS;
